import { UserCoverStyle } from "@authory-packages/core";
import { AuthoryColorSchemes } from "./V3ProfileHero.types";

export const isHexLight = (color: string) => {
    const hex = color.replace("#", "").replace("White", "FFFFFF");
    const c_r = parseInt(hex.substr(0, 2), 16);
    const c_g = parseInt(hex.substr(2, 2), 16);
    const c_b = parseInt(hex.substr(4, 2), 16);
    const brightness = (c_r * 299 + c_g * 587 + c_b * 114) / 1000;
    return brightness > 155;
};

export const getAuthoryColorScheme = (coverStyle?: UserCoverStyle) => {
    if (coverStyle === UserCoverStyle.image || coverStyle === UserCoverStyle.unsplash) return AuthoryColorSchemes.light;
    return AuthoryColorSchemes.userTheme;
};

export const SORTABLE_HOME_IDENTIFIER = "SORTABLE_HOME_IDENTIFIER";
